import * as PIXI from "pixi.js-legacy";
import Frames from "../Modules/Frames";
import {EASE, getTween, getTweenAsync} from "../../framework/src/modules/Tween";
import Commander from "../Commander";
import WildWin from "../animations/WildWin";

export default class BaseSymbol extends PIXI.Sprite {


    constructor(symbolName, index, blur = false) {

        let textureName = blur ? symbolName + "_blur.png" : symbolName + ".png";
        let texture = PIXI.Texture.from(textureName);

        super();
        this.name = symbolName;
        this.symbolName = symbolName;
        this.symbolIndex = index;

        this.symbol = new PIXI.Sprite(texture);
        this.addChild(this.symbol);

        this.symbol.anchor.set(0.5, 0.5);
    }

    blur() {
        this.symbol.texture = PIXI.Texture.from(this.symbolName + "_blur.png");
    }

    unblur() {
        this.symbol.texture = PIXI.Texture.from(this.symbolName + ".png");
    }

    idle(layer = undefined) {

    }

    onStop() {
        // this.filters = [Filters.brightness, Filters.color];
    }

    destroy(options) {
        if (this.spiral) this.spiral.destroy();
        if (this.text) this.text.destroy();
        if (this.shine) this.shine.destroy();
        if (this.shineMask) this.shineMask.destroy();
        this.spiral = this.text = this.shine = this.shineMask = undefined;
        super.destroy(options);
    }

    play(layer) {
        let anim = Frames.getAnimatedSprite(
            Frames.getFramesBySymbol(this.name),
            this.x, this.y, .75, {x:1,y:1},{x:.5,y:.5}
        );
        anim.loop = false;
        layer.addChild(this, anim);
        this.symbol.visible = false;
        anim.play();
        anim.onComplete = () => {
            this.symbol.visible = true;
            layer.removeChild(anim);
            anim.destroy({children: true, texture: false, baseTexture: true});
        };
    }

    async toWild() {
        this.spiral = WildWin.getSpiral();
        this.addChildAt(this.spiral,0);
        getTween(this.spiral, {rotation: Math.PI*6}, 4000, EASE.QUAR_O);
        await getTweenAsync(this.spiral.scale, {x: 1, y: 1}, 800);

        this.symbol.texture = PIXI.Texture.from(this.name+"_morph.png");
        getTween(this.symbol.scale, {x: 0, y: 0}, 433, EASE.QUAR_IO);
        await getTweenAsync(this.symbol, {rotation: Math.PI*3}, 433, EASE.LINEAR);

        this.text = Commander.getSprite("symbol_crystal_wild_text_blur.png", 0,0);
        this.text.scale.set(0,0);
        this.text.rotation = -2.61; // 3.66 rad ~ -150 deg
        this.text.name = "symbol_crystal_wild";
        this.addChild(this.text);
        getTween(this.text,{rotation: 0}, 200);
        await getTweenAsync(this.text.scale, {x: 1.04, y: 1.04}, 233);
        this.text.texture = PIXI.Texture.from("symbol_crystal_wild_text.png");
        await getTweenAsync(this.text.scale, {x: 1, y: 1}, 133);
        this.shine = Commander.getSprite("symbol_crystal_wild_shine_over.png",0,0);
        this.shine.height = this.height/2;
        this.shine.width = this.width/2;

        this.shineMask = Commander.getSprite("symbol_crystal_wild_text_alpha.png", 0,0);
        this.shineMask.mask = this.shine;
        this.shineMask.blendMode = PIXI.BLEND_MODES.ADD;
        this.shine.blendMode = PIXI.BLEND_MODES.ADD;

        getTween(this.shine,{x: this.symbol.width / 2+50}, 633);
        this.addChild(this.shineMask);
        this.addChild(this.shine);
    }

    async spinSpiral() {
        this.symbol.visible = false;
        this.spiral = WildWin.getSpiral();
        this.spiral.scale.set(1,1);
        this.spiral.rotation = -2*Math.PI;
        this.addChildAt(this.spiral,0);
        this.text = Commander.getSprite("symbol_crystal_wild_text.png", 0,0);
        this.text.name = "symbol_crystal_wild";
        this.addChildAt(this.text,1);
        getTweenAsync(this.spiral, {rotation: 0}, 1000, EASE.QUAD_I).then(() => {
            getTween(this.spiral, {rotation: Math.PI*4}, 2800, EASE.QUAD_O);
        });
    }

    setLayer(layer) {
        if (layer)
            layer.addChild(this);
    }
}
